import React from "react";
import { SEQ_STATUS, formatSequentialIls } from "../../../utils/payment/sequentialMultiCardPayment";

function StepGlyph({ status }) {
  if (status === SEQ_STATUS.PAID) {
    return (
      <span className="seq-stepper__glyph seq-stepper__glyph--paid" aria-hidden>
        ✓
      </span>
    );
  }
  if (status === SEQ_STATUS.FAILED) {
    return (
      <span className="seq-stepper__glyph seq-stepper__glyph--failed" aria-hidden>
        !
      </span>
    );
  }
  if (status === SEQ_STATUS.ACTIVE || status === SEQ_STATUS.PROCESSING) {
    return (
      <span className="seq-stepper__glyph seq-stepper__glyph--active" aria-hidden>
        ●
      </span>
    );
  }
  return (
    <span className="seq-stepper__glyph seq-stepper__glyph--pending" aria-hidden>
      ○
    </span>
  );
}

export default function SequentialPaymentProgress({
  requiredIls,
  paidIls,
  remainingIls,
  steps = [],
  successBanner = null,
}) {
  const count = steps.length;
  const active = steps.find(
    (s) =>
      s.status === SEQ_STATUS.ACTIVE ||
      s.status === SEQ_STATUS.PROCESSING ||
      s.status === SEQ_STATUS.FAILED
  );
  const stepNumber = active ? active.index + 1 : count;

  return (
    <div className="seq-progress" dir="rtl">
      <div className="seq-progress__totals">
        <div className="seq-progress__total">
          <span className="seq-progress__label">סה״כ לתשלום</span>
          <span className="seq-progress__value">{formatSequentialIls(requiredIls)}</span>
        </div>
        {count > 1 || Number(paidIls) > 0 ? (
          <div className="seq-progress__split">
            <div className="seq-progress__stat seq-progress__stat--paid">
              <span>שולם</span>
              <strong>{formatSequentialIls(paidIls)}</strong>
            </div>
            <div className="seq-progress__stat seq-progress__stat--remain">
              <span>נותר לתשלום</span>
              <strong>{formatSequentialIls(remainingIls)}</strong>
            </div>
          </div>
        ) : null}
      </div>

      {successBanner ? (
        <div className="seq-progress__banner" role="status">
          ✓ {successBanner}
        </div>
      ) : null}

      {count > 1 ? (
        <>
          <p className="seq-progress__caption">
            תשלום {stepNumber} מתוך {count}
          </p>
          <ol className="seq-stepper" aria-label="התקדמות תשלומים">
            {steps.map((step, i) => (
              <li
                key={`seq-step-${step.index}`}
                className={`seq-stepper__item seq-stepper__item--${String(step.status).toLowerCase()}`}
              >
                <span className="seq-stepper__node">
                  <StepGlyph status={step.status} />
                  <span className="seq-stepper__num">{step.index + 1}</span>
                </span>
                {i < count - 1 ? <span className="seq-stepper__line" aria-hidden /> : null}
              </li>
            ))}
          </ol>
        </>
      ) : null}
    </div>
  );
}
